import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    techniqueCategories: [],
    loading: false,
};

const techniqueCategorySlice = createSlice({
    name: "techniqueCategory",
    initialState,
    reducers: {
        setTechniqueCategories: (state, action) => {
            state.techniqueCategories = action.payload;
        },
        addTechniqueCategory: (state, action) => {
            state.techniqueCategories.push(action.payload);
        },
        editTechniqueCategory: (state, action) => {
            let idx = state.techniqueCategories.findIndex(cat => cat._id === action.payload._id);
            if (idx !== -1) state.techniqueCategories[idx] = action.payload;
        },
        removeTechniqueCategory: (state, action) => {
            state.techniqueCategories = state.techniqueCategories.filter(cat => cat._id !== action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setTechniqueCategories,
    addTechniqueCategory,
    editTechniqueCategory,
    removeTechniqueCategory,
    setLoading
} = techniqueCategorySlice.actions;

export const techniqueCategoryReducers = techniqueCategorySlice.reducer;